"use strict";

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { sideDrawerListLoaded } from 'Actions/SideDrawerListActions';
import { SubsystemsCollection } from "Collections/SubsystemsCollection";
import { Fields } from "Constants/objects";
import { LoginFormConstants } from "Constants/Login/LoginFormConstants";
var DRAWER_WIDTH = 240;
var defStore = {
  loaded: false,
  width: DRAWER_WIDTH
};
var _store = defStore;
var CHANGE_EVENT = 'change';

function getSubSysObjByModel(rest) {
  return _objectSpread({
    Expanded: true,
    IsActive: false,
    Children: []
  }, rest);
}

var SideDrawerStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(SideDrawerStoreClass, _StoreClass);

  function SideDrawerStoreClass() {
    _classCallCheck(this, SideDrawerStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideDrawerStoreClass).call(this));
  }

  _createClass(SideDrawerStoreClass, [{
    key: "doLoadSubsystems",
    value: function doLoadSubsystems() {
      if (_store.loaded) return;
      var collection = new SubsystemsCollection();
      collection.fetch({
        data: {
          Columns: [Fields.ID, Fields.Name, Fields.ParentSubsystemID, Fields.FormID, Fields.IsGroup, Fields.Order, Fields.FormID_Type],
          Page: -1,
          Sorts: [Fields.Order]
        },
        success: function success(coll) {
          var list = _toConsumableArray(coll.toJSON());

          var out = {};
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;
              out[item.ID] = getSubSysObjByModel(item);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var d = [];

          _.each(_objectSpread({}, out), function (item, key) {
            if (item[Fields.ParentSubsystemID] != null) {
              var parent = out[item[Fields.ParentSubsystemID]];

              if (parent) {
                parent.Children.push(item);
                parent.Children = _.sortBy(parent.Children, Fields.Order);
              }

              if (out.hasOwnProperty(key)) d.push(key);
            }
          });

          for (var _i = 0; _i < d.length; _i++) {
            var i = d[_i];
            delete out[i];
          }

          out = _.sortBy(out, Fields.Order);
          _store.loaded = true;
          sideDrawerListLoaded(out);
        }
      });
    }
  }, {
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }]);

  return SideDrawerStoreClass;
}(StoreClass);

var SideDrawerStore = new SideDrawerStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case LoginFormConstants.DO_LOGOUT:
      _store = {
        loaded: false,
        width: DRAWER_WIDTH
      };
      break;

    default:
      return true;
  }
});
export default SideDrawerStore;